import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setLineJobHistoryOperation = (state, { lineJobHistoryOperationData }) => {
  if (!lineJobHistoryOperationData) return state;
  return state.merge({ lineJobHistoryOperationData });
};

const setLineJobHistoryOperationLoaderStatus = (state, { lineJobHistoryOperationLoader }) => {
  return state.merge({ lineJobHistoryOperationLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_LINE_JOB_HISTORY_OPERATION,
    actionFunction: setLineJobHistoryOperation,
  },
  {
    actionType: ActionTypes.SET_LINE_JOB_HISTORY_OPERATION_LOADER_STATUS,
    actionFunction: setLineJobHistoryOperationLoaderStatus,
  },
];
